import { render } from "./HistoricalEntitlementUsageCharts.vue?vue&type=template&id=53eaf7f0&scoped=true"
import script from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"
export * from "./HistoricalEntitlementUsageCharts.vue?vue&type=script&lang=js"

import "./HistoricalEntitlementUsageCharts.vue?vue&type=style&index=0&id=53eaf7f0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eaf7f0"]])

export default __exports__